import { gaTracking, getCurrentPageLocation, normalizeString } from "../../lib/ga";

/**
 * Tracks social share actions
 * @param contentId - ID of the content being shared
 * @param contentType - Type of content (default: "kort")
 */
export const shareImageTracker = (contentId: string, contentType = "kort"): void => {
  gaTracking({
    event: "share",
    event_parameters: {
      page_location: getCurrentPageLocation(),
      content_type: contentType,
      content_id: contentId,
    },
  });
};

/**
 * Tracks image download events
 * @param fileName - Name of the downloaded image
 * @param extention - File extension
 * @see /GAExamples/file_download.js
 */
export const imageDownloadTracker = (fileName: string, extention: string): void => {
  gaTracking({
    event: "file_download",
    event_parameters: {
      page_location: getCurrentPageLocation(),
      file_name: normalizeString(fileName) ?? "",
      file_extension: normalizeString(extention) ?? "",
    },
  });
};
